/* eslint-disable no-underscore-dangle */
/* eslint-disable no-process-env */
export const getConfig = (name) => {
    const envVar = process.env;
    const wind = window;
    const config = wind.__config || envVar || {};
    return config[name];
};
export const getHostName = () => window?.location?.hostname ?? "";
